import { useEffect, useRef } from "react";
import { ResendingTimer } from "../../constants";

export const useTimeout = (ms: number = ResendingTimer) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const setTimer = (callback:()=> void) => {
        clearTimeout(timeoutRef.current!);
        timeoutRef.current = setTimeout(() => callback(), ms);
    };

    const clearTimer = (callback:()=> void) => {
        clearTimeout(timeoutRef?.current!);
          callback();
      };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }, []); 
  
    return [setTimer, clearTimer];
  };